import 'bootstrap/dist/css/bootstrap.min.css'
import React, { Component } from 'react'
import { Button, Col, Container, Form, InputGroup, Nav, Navbar, Row } from 'react-bootstrap'
import * as Icon from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import Thumb from './common/Thumb'

const DLsite = (props) => {
    const {t,i18n} = useTranslation()
    let count = 0
    return (
        props.list !== undefined ? props.list.map((d,i) => {
            if(count > 4) return ""
            count++
            if(d.isAd){
                return (
                    <div style={{width:"200px",height:"200px",overflow:"hidden",whiteSpace:"nowrap",borderRadius:"10px"}} className='m-3'>
                        <a style={{textDecoration:"none",color:"black",fontSize:"14px"}} rel="noopener sponsored" href={d.to} target="_blank"><img itemprop="image" src={d.img} alt="" border="0" width={200} className="target_type" style={{borderRadius:"10px"}} />
                        <br />
                        {d.title}<br />
                        [PR] {d.cicle}
                        </a>
                    </div>
                    )
            } else {
                return <Thumb data={d} i={i} dialog={props.dialog} key={i} from="popup" list={props.imageList.filter(d => d.mute === 0)}
                onClick={() => {
                    if(props.setViewList === undefined){
                        window.location.href = "/image/" + d.group_id
                    } else {
                        props.setViewList(props.imageList.filter(d => d.mute === 0))
                        props.setViewListIndex(i)

                        props.setGroupId(d.group_id)
                        // スクロールを最上位に戻す
                        document.getElementById("popup-view").scrollTo({top:0,left:0,behavior:"instant"})
                        props.setDetailNo(0)
                    }
                }}
                />
            }
        }) : ""
    )
}

export default DLsite;